import React from 'react';
// src/components/Sections/TestimonialsSection.js
import { TestimonialCard } from '../UI/TestimonialCard.js';
import { testimonials } from '../../data/testimonials.js';

const reviewSchema = {
  '@context': 'https://schema.org',
  '@type': 'LocalBusiness',
  name: 'Cassidy Sullivan Photography',
  url: 'https://www.cassidysullivanphotography.com',
  aggregateRating: {
    '@type': 'AggregateRating',
    ratingValue: (testimonials.reduce((total, testimonial) => total + testimonial.rating, 0) / testimonials.length).toFixed(1),
    reviewCount: testimonials.length
  },
  review: testimonials.map((testimonial) => ({
    '@type': 'Review',
    reviewRating: {
      '@type': 'Rating',
      ratingValue: testimonial.rating,
      bestRating: 5
    },
    author: {
      '@type': 'Person',
      name: testimonial.name
    },
    reviewBody: testimonial.text
  }))
};

export const TestimonialsSection = () => {
  return React.createElement("section", {
    id: "testimonials",
    className: "scroll-mt-24 py-20 md:py-24 bg-gradient-to-r from-slate-100 via-gray-50 to-slate-100"
  },
    React.createElement('script', {
      type: 'application/ld+json',
      dangerouslySetInnerHTML: { __html: JSON.stringify(reviewSchema) }
    }),
    React.createElement("div", {
      className: "max-w-6xl mx-auto px-4 sm:px-6 lg:px-8"
    },
      React.createElement("h2", {
        className: "text-4xl font-bold text-center mb-12"
      }, "What Clients Say"),
      
      React.createElement("div", {
        className: "grid grid-cols-1 md:grid-cols-3 gap-8"
      }, testimonials.map((testimonial, index) =>
        React.createElement(TestimonialCard, {
          key: index,
          testimonial: testimonial
        })
      ))
    )
  );
};